import { UPDATE_PROFIT_BY_SKU_WIDGET } from "./actionTypes"

export const updateProfitBySkuWidget = data => {
  return {
    type: UPDATE_PROFIT_BY_SKU_WIDGET,
    payload: data,
  }
}
